import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/emails' }, ServiceProxyMap.ANS);

export const partnerEmailAttachmentHandler = async (attachmentId: string) => {
  const response = await client.get(`/attachments/${attachmentId}/getSignedUrl`);
  return response.data;
};
